import * as Brand from 'effect/Brand';
import * as Data from 'effect/Data';
import * as Equivalence from 'effect/Equivalence';

/**
 * Agency currently refers to any entity that is not an Organization.
 * This includes actual agencies, in-house and marketplace entitites.
 *
 * Uses the internal Customer Entities
 */

export type AgencyId = number & Brand.Brand<'AgencyId'>;
export const AgencyId = Brand.nominal<AgencyId>();

export interface AgencyRef {
  readonly _tag: 'AgencyRef';
  readonly id: AgencyId;
  readonly name: string;
}
export const AgencyRef = Data.tagged<AgencyRef>('AgencyRef');
export const AgencyEquivalence = Equivalence.mapInput(
  Equivalence.string,
  (r: AgencyRef) => `${r.id}`,
);
